import { render, staticRenderFns } from "./EmptyListPlaceholder.vue?vue&type=template&id=03fa9888&scoped=true"
import script from "./EmptyListPlaceholder.vue?vue&type=script&lang=js"
export * from "./EmptyListPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fa9888",
  null
  
)

export default component.exports